module.exports = __webpack_public_path__ + "static/media/info_6.42e78265.svg";